import { Link } from "react-router-dom";
const HomeSrilanka = () => {
  return <section className="w-full bg-gradient-to-b from-white via-[#f8f5f1] to-white py-16 sm:py-20 lg:py-28">
            <div className="container mx-auto px-4">
                {
    /* Mobile Layout - sm and below */
  }
                <div className="lg:hidden flex flex-col gap-8">
                    {
    /* Label */
  }
                    <p className="text-sm font-semibold uppercase tracking-[0.35em] text-amber-800">
                        Sri Lanka
                    </p>
                    <h2 className="font-serif text-2xl font-light leading-tight tracking-tight text-[#1f4d3c] sm:text-3xl">
                        Die Insel aus Licht und Vielfalt im Indischen Ozean
                    </h2>

                    {
    /* Image */
  }
                    <div className="relative h-[280px] overflow-hidden sm:h-[380px]">
                        <img
    src="/images/Hiru/front_srilanka_teaser.webp"
    alt="Landschaft in Sri Lanka"className="object-contain" style={{ position: "absolute", inset: 0, width: "100%", height: "100%" }} loading="lazy" />
                    </div>

                    {
    /* Content */
  }
                    <div>


                        <div className="mt-5 space-y-4 text-[15px] leading-relaxed text-gray-700 sm:text-base">
                            <p>
                                Ayurveda in Sri Lanka ist weltweit bekannt und seine Geschichte reicht über 2.500 Jahre zurück – von königlichen Familien bis zu einfachen Menschen hat es eine tiefe Tradition und breite Akzeptanz gefunden.
                            </p>
                            <p>
                                Heute ist Ayurveda Teil des öffentlichen Gesundheitssystems, und Menschen aus aller Welt reisen nach Sri Lanka, um diese traditionelle Heilkunst zu erleben. Das beliebteste Reiseziel für Ayurveda unter Japanern ist Sri Lanka.
                            </p>

                            <p className="text-base font-semibold tracking-[0.18em] text-[#1f4d3c] sm:text-lg">
                                Reiches Gleichgewicht aus vielfältigen Kulturen
                            </p>

                            <p>
                                Als „Perle des Indischen Ozeans“ ist diese Insel früher unter dem Namen Ceylon bekannt gewesen. Heute lebt hier eine Bevölkerung von rund 22 Millionen Menschen in einer demokratischen sozialistischen Republik, in der Religion und Ethnie keine trennende, sondern verbindende Rolle spielen. Neben den Amtssprachen Sinhala und Tamil wird auch Englisch im Handel und in der Bildung häufig verwendet. Diese sprachliche Vielfalt spiegelt die lange Geschichte der Insel wider, die als bedeutender Knotenpunkt im Seehandel zwischen Westasien und Südostasien viele Kulturen aufnahm. Schon lange vor der Kolonialzeit unter Portugiesen, Holländern und Briten war Sri Lanka ein bedeutendes Zentrum des alten Buddhismus.
                            </p>
                        </div>

                        <div className="mt-8">
                            <Link
    to="/about"
    className="inline-flex items-center justify-center rounded-full bg-[#F28600] px-6 py-2.5 text-sm font-semibold text-white shadow-lg shadow-[#f28600]/25 transition hover:bg-[#d67000]"
  >
                                Mehr erfahren
                            </Link>
                        </div>
                    </div>
                </div>

                {
    /* Desktop Layout - lg and above */
  }
                <div className="hidden lg:flex flex-col gap-10 lg:flex-row lg:items-center lg:gap-16">
                    <div className="lg:w-5/12">
                        <div className="relative h-[320px] overflow-hidden sm:h-[420px] lg:h-[660px]">
                            <img
    src="/images/Hiru/front_srilanka_teaser.webp"
    alt="Landschaft in Sri Lanka"className="object-contain" style={{ position: "absolute", inset: 0, width: "100%", height: "100%" }} loading="lazy" />
                        </div>
                    </div>

                    <div className="lg:w-7/12">
                        <p className="mb-4 text-sm font-semibold uppercase tracking-[0.35em] text-amber-800">
                            Sri Lanka
                        </p>

                        <h2 className="font-serif text-3xl font-light leading-tight tracking-tight text-[#1f4d3c] sm:text-4xl lg:text-5xl">
                            Die Insel aus Licht und Vielfalt im Indischen Ozean
                        </h2>

                        <div className="mt-8 space-y-5 text-[17px] leading-relaxed text-gray-700 lg:text-lg">
                            <p>
                                Ayurveda in Sri Lanka ist weltweit bekannt und seine Geschichte reicht über 2.500 Jahre zurück – von königlichen Familien bis zu einfachen Menschen hat es eine tiefe Tradition und breite Akzeptanz gefunden.
                            </p>
                            <p>
                                Heute ist Ayurveda Teil des öffentlichen Gesundheitssystems, und Menschen aus aller Welt reisen nach Sri Lanka, um diese traditionelle Heilkunst zu erleben. Das beliebteste Reiseziel für Ayurveda unter Japanern ist Sri Lanka.
                            </p>

                            <p className="text-lg font-semibold tracking-[0.18em] text-[#1f4d3c]">
                                Reiches Gleichgewicht aus vielfältigen Kulturen
                            </p>

                            <p>
                                Als „Perle des Indischen Ozeans“ ist diese Insel früher unter dem Namen Ceylon bekannt gewesen. Heute lebt hier eine Bevölkerung von rund 22 Millionen Menschen in einer demokratischen sozialistischen Republik, in der Religion und Ethnie keine trennende, sondern verbindende Rolle spielen. Neben den Amtssprachen Sinhala und Tamil wird auch Englisch im Handel und in der Bildung häufig verwendet. Diese sprachliche Vielfalt spiegelt die lange Geschichte der Insel wider, die als bedeutender Knotenpunkt im Seehandel zwischen Westasien und Südostasien viele Kulturen aufnahm. Schon lange vor der Kolonialzeit unter Portugiesen, Holländern und Briten war Sri Lanka ein bedeutendes Zentrum des alten Buddhismus.
                            </p>
                        </div>

                        <div className="mt-10">
                            <Link
    to="/about"
    className="inline-flex items-center justify-center rounded-full bg-[#F28600] px-7 py-3 text-sm font-semibold text-white shadow-lg shadow-[#f28600]/25 transition hover:bg-[#d67000]"
  >
                                Mehr über Sri Lanka erfahren
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>;
};
export default HomeSrilanka;
